module.exports = __webpack_public_path__ + "static/media/manOnTable.83ac24fb.svg";